import { useAuth0 } from "@auth0/auth0-react";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { Text } from "components";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import { FormikWizard } from "formik-wizard-form";
import AuthService from "Lib/API/Auth";
import { values } from "lodash";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import NotAuthorized from "../../../components/NotAuthorized";
import AddittionalInformation from "./AddittionalInformation";
import AddMourners from "./AddMourners";
import DeceacedDetails from "./DeceacedDetails";
import "./index.scss";
import MournersList from "./MournersList";
import { DeceacedDetailsSchema } from "./StepsValidation";

const NewYahrzeit = ({
  closeModal,
  isOpenMergePopUp,
  setRefresh,
  refresh,
  ...props
}) => {
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [isYahrzeitActive, setIsYahrzeitActive] = useState(true);
  const [finalValues, setFinalValues] = useState({});
  const [finished, setFinished] = useState(false);
  const [mourners, setMourners] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mourner, setMourner] = useState(false);
  const formik = { ...props };
  const [isLoading, setIsLoading] = useState(false);
  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "yahrzeit") {
        return setIsYahrzeitActive(item?.active);
      }
    });
  }, []);
  const handleDeleteMourner = (index) => {
    var array = [...mourners];
    if (index !== -1) {
      array.splice(index, 1);
      setMourners(array);
    }
  };

  useEffect(() => {
    //when finished call api to create yaherzit
    async function handleCreate() {
      setIsLoading(true);
      const token = await getAccessTokenSilently();
      await AuthService.postAddDeceased(finalValues, token)
        .then((res) => {
          setLoading(false);
          setIsLoading(false);
          toastr.success("Success", "Yahrzeit has been created successfully");
          closeModal();
          setRefresh(!refresh);
        })
        .catch((err) => {
          setLoading(false);
          setIsLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    if (finalValues?.firstName && finalValues?.lastName) handleCreate();
  }, [finished]);

  return isYahrzeitActive == false ? (
    <NotAuthorized title={"Yahrzeit"} />
  ) : (
    <div className="w-100">
      <FormikWizard
        initialValues={{
          functions: { setMourners: setMourners },
          firstName: "",
          lastName: "",
          hebrew_name: "",
          date_of_death: "",
          hebrew_date: "",
          before_sunset: false,
          has_plaque: false,
          doesnt_have_mourner: false,
          mourners_list: [],
          plaques_number: "",
          cemetery: "",
          about_deceased: "",
        }}
        onSubmit={(values) => {
          setTimeout(() => {
            setFinished(true);
          }, 2000);
          setMourner(values?.doesnt_have_mourner);
          const mourners_list = mourners.map((mourner) => {
            const { firstName, lastName, ...data } = { ...mourner };
            return data;
          });
          const input = {
            firstName: values?.firstName,
            lastName: values?.lastName,
            date_of_death: values?.date_of_death,
            hebrew_date_of_death: values?.hebrew_date,
            before_sunset: values?.before_sunset,
            has_plaque: values?.has_plaque === true ? "Yes" : "No",
            doesnt_have_mourner:
              values?.doesnt_have_mourner === true ? "Yes" : "No",
            mourners_list: mourners_list,
          };

          if (values?.plaques_number)
            input.plaque_number = values?.plaques_number;
          if (values?.cemetery) input.cemetery = values?.cemetery;
          if (values?.hebrew_name)
            input.hebrew_name_of_Death = values?.hebrew_name;
          if (values?.about_deceased)
            input.about_the_deceased = values?.about_deceased;
          if (values?.account) input.account = values?.account;
          setFinalValues(input);
        }}
        validateOnNext
        activeStepIndex={0}
        steps={[
          {
            component: DeceacedDetails,
            validationSchema: DeceacedDetailsSchema,
          },
          {
            component: AddMourners,
          },
          {
            component: AddittionalInformation,
          },
        ]}
      >
        {({
          currentStepIndex,
          renderComponent,
          handlePrev,
          handleNext,
          isNextDisabled,
          isPrevDisabled,
          ...props
        }) => {
          return (
            <div className="new-yahrzeit">
              <hr className="mt-0" />
              <div className="yahrzeit-header py-7">
                <div className="fom-steps">
                  <Stepper activeStep={currentStepIndex}>
                    <Step completed={currentStepIndex > 0} className="step">
                      <StepLabel className="step-label">
                        Deceased details
                      </StepLabel>
                    </Step>
                    <Step completed={currentStepIndex > 1}>
                      <StepLabel>Add Mourners</StepLabel>
                    </Step>
                    <Step completed={finished}>
                      <StepLabel>Additional information</StepLabel>
                    </Step>
                  </Stepper>
                </div>
              </div>
              <div className="d-flex pb-5">
                <div className="form-content-yahrzeit pr-10">
                  <div className="form-details">{renderComponent()}</div>
                  <div
                    className={
                      currentStepIndex !== 0
                        ? "form-footer-prev py-10"
                        : "form-footer"
                    }
                  >
                    {currentStepIndex !== 0 && (
                      <Button
                        variant="primary-outline"
                        size="md"
                        style={{ minWidth: "150px" }}
                        onClick={handlePrev}
                        disabled={isPrevDisabled}
                      >
                        Previous
                      </Button>
                    )}
                    {currentStepIndex !== 1 && (
                      <Button
                      variant="primary"
                      size="md"
                      style={{ minWidth: "150px" }}
                      onClick={handleNext}
                      disabled={isNextDisabled}
                      >
                        {
                          isLoading ? (
                            <PulseLoader
                              color={"#fff"}
                              size={"7px"}
                              style={{ marginTop: "-2px" }}
                            />
                          ) : currentStepIndex === 2 ? (
                            "Create yahrzeit"
                          ) : (
                            "Continue"
                          )
                        }
                      </Button>
                    )}
                  </div>
                </div>
                {currentStepIndex === 1 && (
                  <MournersList
                    handleDelete={handleDeleteMourner}
                    handleClick={handleNext}
                    mourners={mourners}
                    setDisable={setDisable}
                    {...props}
                  />
                )}
              </div>
            </div>
          );
        }}
      </FormikWizard>
      <AlertDialog
        open={openModal}
        handleClose={() => setOpenModal(false)}
        onDecline={() => setOpenModal(false)}
        onAccept={() => setFinished(true)}
        title="Are you sure?"
        description="Do you want to create new yahrzeit?"
      />
    </div>
  );
};

export default NewYahrzeit;
